import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { LocationApiAdapter } from '../adapters/LocationApiAdapter';
import { LocationService } from '../services/LocationService';

interface UpdateLocationData {
  id: number;
  code: string;
  type_id: number;
  rack_id?: number | null;
  shelf?: number | null;
  slot?: number | null;
}

export const useUpdateLocation = () => {
  const queryClient = useQueryClient();

  // 🎯 Memoizar instancias del servicio para evitar recrearlas en cada render
  const locationService = useMemo(() => {
    const httpClient = createHttpClient(apiClientWH);
    const apiAdapter = new LocationApiAdapter(httpClient);
    return new LocationService(apiAdapter);
  }, []);

  return useMutation({
    mutationFn: (data: UpdateLocationData) =>
      locationService.updateLocation(data.id, {
        code: data.code,
        type_id: data.type_id,
        rack_id: data.rack_id,
        shelf: data.shelf,
        slot: data.slot,
      }),
    onSuccess: () => {
      // Invalidar las queries de locations y racks para refrescar la lista
      queryClient.invalidateQueries({ queryKey: ['locations'] });
      queryClient.invalidateQueries({ queryKey: ['warehouse-racks'] });
    },
  });
};
